
import { useJoinCooperate } from '../cooperateModel'
import { ISearchValue, SearchTypeEnum } from '@/components/YhPageHeader/Types'
import { YhPageHeader } from '@/components/YhPageHeader'
import { useDictModel } from '@/views/base/dict/dictModel'
import { DictCodeEnmu } from '@/types/AppDictEnums'

export function PageHeader() {
    const { getSelectedDictOne } = useDictModel(() => []);
    const { searchParam, updateSearchParam, resetSearchParam, loadData } = useJoinCooperate()

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: '加盟商名称',
            fieldName: 'name',
            span:3
        },
    ]


    return (
        <YhPageHeader
            title=""
            size="small"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    )
}
